export const ACTION_TYPES = {
  UPDATE_CUSTOMER: 'customer/UPDATE_CUSTOMER',
  RESET_ADDRESS: 'customer/RESET_ADDRESS'
};
